import React from 'react';
import { Helmet } from 'react-helmet';
import BoostYourBrand from './BoostYourBrand';

const BoostBrandPage = () => (
  <>
    <Helmet>
      <title>Branding and Digital Solutions | MilaajBrandset</title>
      <meta
        name="description"
        content="Elevate your brand with MilaajBrandset's cutting-edge social media management, strategic brand positioning, and creative solutions. Let's make your brand shine."
      />
      <meta
        name="keywords"
        content="branding, social media management, digital solutions, MilaajBrandset, brand positioning, creative content, video production, paid media campaigns"
      />
      <meta property="og:title" content="Branding and Digital Solutions | MilaajBrandset" />
      <meta
        property="og:description"
        content="Elevate your brand with MilaajBrandset's cutting-edge social media management, strategic brand positioning, and creative solutions. Let's make your brand shine."
      />
      <meta property="og:image" content="https://www.milaajbrandset.com/images/branding-og-image.jpg" />
    </Helmet>
    <BoostYourBrand />
  </>
);

export default BoostBrandPage;